import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// NOTE: React.StrictMode intentionally double-mounts effects in development,
// which breaks react-leaflet's MapContainer ("Map container is already
// initialized"). StrictMode is a dev-only checker, so disabling it here does
// not affect production behaviour.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
